import { render, staticRenderFns } from "./ComposeComponent.vue?vue&type=template&id=7f831f1c&scoped=true&"
import script from "./ComposeComponent.vue?vue&type=script&lang=js&"
export * from "./ComposeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f831f1c",
  null
  
)

export default component.exports